import React from 'react'
import EventWeb from './EventWeb'
import EventMobile from './EventMobile'

export default function Event({ isMobile }) {

    return (
        isMobile === true ?
        <EventMobile/>
        :
        <EventWeb/>
        
    )

}
